import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MAT_DATE_FORMATS, NativeDateAdapter, DateAdapter } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

export const DD_MM_YYYY_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${this._to2digit(day)}/${this._to2digit(month)}/${year}`;
  }

  private _to2digit(n: number): string {
    return ('00' + n).slice(-2);
  }

  override parse(value: any, parseFormat: any): Date | null {
    if (!value) return null;
    
    const parts = value.split('/');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      
      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        return new Date(year, month, day);
      }
    }
    
    return super.parse(value, parseFormat);
  }
}

@Component({
    selector: 'app-basic-datepicker',
    imports: [MatCardModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, MatIconModule, MatButtonModule , TranslatePipe],
    templateUrl: './basic-datepicker.component.html',
    styleUrl: './basic-datepicker.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_FORMAT }
    ]
})
export class BasicDatepickerComponent {

    @Output() dateChange = new EventEmitter<Date>();

    selectedDate: Date = new Date();

    get isNextDayDisabled(): boolean {
        const today = new Date();
        const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const current = new Date(
            this.selectedDate.getFullYear(),
            this.selectedDate.getMonth(),
            this.selectedDate.getDate()
        );
        return current >= todayMidnight;
    }

    ngOnInit(): void {
        this.emitCurrentDate();
    }

    private emitCurrentDate(): void {
        this.dateChange.emit(this.selectedDate);
    }

    onDateChange(event: MatDatepickerInputEvent<Date>) {
        const value = event.value;
        if (!value) {
            return;
        }
        this.selectedDate = value;
        this.emitCurrentDate();
    }

    goToPreviousDay(): void {
        const d = new Date(this.selectedDate);
        d.setDate(d.getDate() - 1);
        this.selectedDate = d;
        this.emitCurrentDate();
    }

    goToNextDay(): void {
        if (this.isNextDayDisabled) {
            return;
        }
        const d = new Date(this.selectedDate);
        d.setDate(d.getDate() + 1);
        this.selectedDate = d;
        this.emitCurrentDate();
    }
}